import type {CSSProperties} from 'react';
import {WEDGE_SHELL as B, WEDGE_NOTICE as N} from '@territory/tokens';
import {font, radius, space, weight} from '../scale.js';

export type WedgeRedirectLook = 'copy-code' | 'share-retry';
/* Released off-scale anchor type and tracking. Both routes inherit their distinct native host font. */
const REDIRECT_FONT = font.body + 0.5;
const REDIRECT_TRACK = 0.1;
const REDIRECT_PY = 13;
export function wedgeRedirectStyle(look: WedgeRedirectLook): CSSProperties {
  const copy = look === 'copy-code';
  return {
    display: 'inline-block', padding: `${REDIRECT_PY}px ${space[7]}px`,
    background: copy ? B.accent : N.shareButton,
    color: copy ? B.accentInk : N.shareButtonText,
    textDecoration: 'none', borderRadius: copy ? radius.lg : radius.md,
    fontWeight: weight.bold, fontSize: REDIRECT_FONT, letterSpacing: REDIRECT_TRACK,
    boxShadow: copy ? B.ctaShadow : N.shareButtonShadow,
  };
}
